export const courierPartnersKeys = [
  {
    name: "Name",
    key: "name",
  },
  {
    name: "Description",
    key: "description",
  },
];
